export class SimplePopup {

	constructor($el, options) {
		this.$el = $el
		this.options = Object.assign({
			placement: 'bottom',
			trigger: 'focus',
			boundary: 'viewport'
		}, options)

		this.init()
	}

	init() {
		this.$el.popover(this.options)
		if (this.options.trigger === 'focus') {
			let _this = this;
			document.querySelector('main').addEventListener('click', function () {
				_this.hide()
			}, true);
		}
	}

	hide() {
		this.$el.popover('hide');
	}

	show() {
		this.$el.popover('show');
	}

}